import { useNavigate, useLocation } from 'react-router-dom'

interface TopBarProps {
  title?: string
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
}

const pageTitles: Record<string, string> = {
  '/dashboard': 'Kegiatan',
  '/laporan': 'Laporan',
  '/pimpinan': 'Pimpinan',
  '/settings': 'Pengaturan',
  '/stadion': 'Dashboard Stadion',
  '/program-kerja': 'Program Kerja',
}

export default function TopBar({ leftIcon, rightIcon }: TopBarProps) {
  const navigate = useNavigate()
  const location = useLocation()

  const title = pageTitles[location.pathname] || 'ISWARA PW Jawa Timur'

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-primary shadow-topbar">
      <div className="max-w-2xl mx-auto h-14 flex items-center justify-between px-4">
        <div className="w-10 flex items-center justify-start">
          {leftIcon || (
            <button
              onClick={() => navigate(-1)}
              className="text-white/80 hover:text-white transition-colors p-1"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          )}
        </div>

        <h1 className="text-white font-bold text-base truncate">{title}</h1>

        <div className="w-10 flex items-center justify-end">
          {rightIcon || null}
        </div>
      </div>
    </header>
  )
}
